/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateSeriesRequest,
    EditSeriesRequest,
    IdResponse,
    LinkPopClipToSeriesRequest,
    PatchSeriesElementRequest,
} from '../models';

export interface SeriesApiControllerArchiveSeriesRequest {
    storeId: string;
    id: string;
}

export interface SeriesApiControllerCreateSeriesRequest {
    storeId: string;
    createSeriesRequest: CreateSeriesRequest;
}

export interface SeriesApiControllerDeleteSeriesRequest {
    storeId: string;
    id: string;
}

export interface SeriesApiControllerDeleteSeriesElementRequest {
    storeId: string;
    seriesId: string;
    id: string;
}

export interface SeriesApiControllerEditSeriesRequest {
    storeId: string;
    id: string;
    editSeriesRequest: EditSeriesRequest;
}

export interface SeriesApiControllerLinkPopClipsRequest {
    storeId: string;
    id: string;
    linkPopClipToSeriesRequest: LinkPopClipToSeriesRequest;
}

export interface SeriesApiControllerPatchSeriesElementRequest {
    storeId: string;
    seriesId: string;
    id: string;
    patchSeriesElementRequest: PatchSeriesElementRequest;
}

export interface SeriesApiControllerUnarchiveSeriesRequest {
    storeId: string;
    id: string;
}

/**
 * 
 */
export class SeriesApi extends runtime.BaseAPI {

    /**
     */
    async seriesApiControllerArchiveSeriesRaw(requestParameters: SeriesApiControllerArchiveSeriesRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling seriesApiControllerArchiveSeries.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling seriesApiControllerArchiveSeries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/series/{id}:archive`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async seriesApiControllerArchiveSeries(requestParameters: SeriesApiControllerArchiveSeriesRequest): Promise<void> {
        await this.seriesApiControllerArchiveSeriesRaw(requestParameters);
    }

    /**
     */
    async seriesApiControllerCreateSeriesRaw(requestParameters: SeriesApiControllerCreateSeriesRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling seriesApiControllerCreateSeries.');
        }

        if (requestParameters.createSeriesRequest === null || requestParameters.createSeriesRequest === undefined) {
            throw new runtime.RequiredError('createSeriesRequest','Required parameter requestParameters.createSeriesRequest was null or undefined when calling seriesApiControllerCreateSeries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/series`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createSeriesRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async seriesApiControllerCreateSeries(requestParameters: SeriesApiControllerCreateSeriesRequest): Promise<IdResponse> {
        const response = await this.seriesApiControllerCreateSeriesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async seriesApiControllerDeleteSeriesRaw(requestParameters: SeriesApiControllerDeleteSeriesRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling seriesApiControllerDeleteSeries.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling seriesApiControllerDeleteSeries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/series/{id}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async seriesApiControllerDeleteSeries(requestParameters: SeriesApiControllerDeleteSeriesRequest): Promise<void> {
        await this.seriesApiControllerDeleteSeriesRaw(requestParameters);
    }

    /**
     */
    async seriesApiControllerDeleteSeriesElementRaw(requestParameters: SeriesApiControllerDeleteSeriesElementRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling seriesApiControllerDeleteSeriesElement.');
        }

        if (requestParameters.seriesId === null || requestParameters.seriesId === undefined) {
            throw new runtime.RequiredError('seriesId','Required parameter requestParameters.seriesId was null or undefined when calling seriesApiControllerDeleteSeriesElement.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling seriesApiControllerDeleteSeriesElement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/series/{seriesId}/elements/{id}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"seriesId"}}`, encodeURIComponent(String(requestParameters.seriesId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async seriesApiControllerDeleteSeriesElement(requestParameters: SeriesApiControllerDeleteSeriesElementRequest): Promise<void> {
        await this.seriesApiControllerDeleteSeriesElementRaw(requestParameters);
    }

    /**
     */
    async seriesApiControllerEditSeriesRaw(requestParameters: SeriesApiControllerEditSeriesRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling seriesApiControllerEditSeries.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling seriesApiControllerEditSeries.');
        }

        if (requestParameters.editSeriesRequest === null || requestParameters.editSeriesRequest === undefined) {
            throw new runtime.RequiredError('editSeriesRequest','Required parameter requestParameters.editSeriesRequest was null or undefined when calling seriesApiControllerEditSeries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/series/{id}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editSeriesRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async seriesApiControllerEditSeries(requestParameters: SeriesApiControllerEditSeriesRequest): Promise<void> {
        await this.seriesApiControllerEditSeriesRaw(requestParameters);
    }

    /**
     */
    async seriesApiControllerLinkPopClipsRaw(requestParameters: SeriesApiControllerLinkPopClipsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling seriesApiControllerLinkPopClips.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling seriesApiControllerLinkPopClips.');
        }

        if (requestParameters.linkPopClipToSeriesRequest === null || requestParameters.linkPopClipToSeriesRequest === undefined) {
            throw new runtime.RequiredError('linkPopClipToSeriesRequest','Required parameter requestParameters.linkPopClipToSeriesRequest was null or undefined when calling seriesApiControllerLinkPopClips.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/series/{id}:linkPopClips`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.linkPopClipToSeriesRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async seriesApiControllerLinkPopClips(requestParameters: SeriesApiControllerLinkPopClipsRequest): Promise<void> {
        await this.seriesApiControllerLinkPopClipsRaw(requestParameters);
    }

    /**
     */
    async seriesApiControllerPatchSeriesElementRaw(requestParameters: SeriesApiControllerPatchSeriesElementRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling seriesApiControllerPatchSeriesElement.');
        }

        if (requestParameters.seriesId === null || requestParameters.seriesId === undefined) {
            throw new runtime.RequiredError('seriesId','Required parameter requestParameters.seriesId was null or undefined when calling seriesApiControllerPatchSeriesElement.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling seriesApiControllerPatchSeriesElement.');
        }

        if (requestParameters.patchSeriesElementRequest === null || requestParameters.patchSeriesElementRequest === undefined) {
            throw new runtime.RequiredError('patchSeriesElementRequest','Required parameter requestParameters.patchSeriesElementRequest was null or undefined when calling seriesApiControllerPatchSeriesElement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/series/{seriesId}/elements/{id}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"seriesId"}}`, encodeURIComponent(String(requestParameters.seriesId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchSeriesElementRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async seriesApiControllerPatchSeriesElement(requestParameters: SeriesApiControllerPatchSeriesElementRequest): Promise<void> {
        await this.seriesApiControllerPatchSeriesElementRaw(requestParameters);
    }

    /**
     */
    async seriesApiControllerUnarchiveSeriesRaw(requestParameters: SeriesApiControllerUnarchiveSeriesRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling seriesApiControllerUnarchiveSeries.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling seriesApiControllerUnarchiveSeries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/series/{id}:unarchive`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async seriesApiControllerUnarchiveSeries(requestParameters: SeriesApiControllerUnarchiveSeriesRequest): Promise<void> {
        await this.seriesApiControllerUnarchiveSeriesRaw(requestParameters);
    }

}
